import Environment from '@di-shared/features/environment/Environment';
import Eu from '@di-shared/features/history/filtered/FilteredDateHistoryResult/.eu';
import Kr from '@di-shared/features/history/filtered/FilteredDateHistoryResult/.kr';
import Na from '@di-shared/features/history/filtered/FilteredDateHistoryResult/.na';

interface FilteredDateHistoryResultProps {
  vin: string;
}

export default function FilteredDateHistoryResult({vin}: FilteredDateHistoryResultProps) {
  return (
    <>
      <Environment.Eu>
        <Eu vin={vin} />
      </Environment.Eu>
      <Environment.Kr>
        <Kr vin={vin} />
      </Environment.Kr>
      <Environment.Na>
        <Na vin={vin} />
      </Environment.Na>
    </>
  );
}
